import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModelT } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import { ServiceDefinitionModel } from "./ServiceDefinitionModel";

class ServiceModel {
    public ServiceID: string;
    public IsInactive: boolean;
    public ServiceDefinitionModel: ServiceDefinitionModel;

    constructor(serviceID: string = null, serviceDefinitionModel: ServiceDefinitionModel = null) {
        if (serviceID) {
            this.ServiceID = serviceID;
        }
        if (serviceDefinitionModel) {
            this.ServiceDefinitionModel = serviceDefinitionModel;
        }
    }

    public ToCheckableUIModel(Target: CheckboxTarget): CheckboxUIModelT<ServiceModel> {
        var service = new CheckboxUIModelT<ServiceModel>();
        service.Model = this;
        service.Name = this.ServiceDefinitionModel.Name;
        service.Id = this.ServiceID;
        service.Target = Target;
        service.Checked = false;

        return service;
    }

    public GetDefaultDurationMinutes(): number {
        return this.ServiceDefinitionModel.GetDefaultDurationMinutes();
    }

    public GetName(): string {
        return this.ServiceDefinitionModel.Name;
    }

    public GetNameWithDuration(): string {
        return this.ServiceDefinitionModel.Name + " - " + this.ServiceDefinitionModel.Model.DefaultDuration / 600000000 + "min";
    }

    public GetDurationInMinutes(): number {
        return this.ServiceDefinitionModel.Model.DefaultDuration / 600000000;
    }

    public GetDurationString(): string {
        return this.ServiceDefinitionModel.Model.DefaultDuration / 600000000 + "min";
    }
}

export { ServiceModel };
